const initialState = {
  errors: [],
  successes: [],
}

export default (state = initialState, action) => {
  switch (action.type) {
    default:
      return state
  }
}

export const getErrors = (state) => {
  return state.notifications.errors
}

export const getSuccesses = (state) => {
  return state.notifications.successes
}
